import React from 'react';
import styled from '@emotion/styled';

const TrafficLightContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.75rem;
`;

const TrafficSignal = styled.div`
  width: 20px;
  height: 40px;
  background-color: transparent;
  border: 1px solid rgba(156, 163, 175, 0.5);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 3px;
`;

const Light = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 3px;
  transition: all 0.3s ease;
  
  /* Base colors for all lights */
  ${props => props.color === 'red' && `
    background-color: #e74c3c;
  `}
  
  ${props => props.color === 'yellow' && `
    background-color: #f39c12;
  `}
  
  ${props => props.color === 'green' && `
    background-color: #10b981;
  `}
  
  /* Opacity based on active state */
  ${props => props.isActive ? `
    opacity: 1;
  ` : `
    opacity: 0.15;
  `}
`;

const TrafficLightStatus = ({ status = 'open' }) => {
  const getStatusConfig = (status) => {
    switch (status.toLowerCase()) {
      case 'open':
        return {
          activeLight: 'green',
          label: 'Open'
        };
      case 'closed':
        return {
          activeLight: 'red',
          label: 'Closed'
        };
      case 'danger':
      case 'escalation':
        return {
          activeLight: 'yellow',
          label: 'Danger'
        };
      default:
        return {
          activeLight: 'green',
          label: 'Open'
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <TrafficLightContainer>
      <TrafficSignal>
        <Light 
          color="red" 
          isActive={config.activeLight === 'red'}
        />
        <Light 
          color="yellow" 
          isActive={config.activeLight === 'yellow'}
        />
        <Light 
          color="green" 
          isActive={config.activeLight === 'green'}
        />
      </TrafficSignal>
    </TrafficLightContainer>
  );
};

export default TrafficLightStatus;
